var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningAmberOutlinedRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "warning",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 24,
    height: 24,
    fill: "#334856",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_625",
    "data-name": "Trac\\xE9 625",
    d: "M10,16h2V14H10Zm0-4h2V8H10Zm1-8.01L18.53,17H3.471ZM11,0,0,19H22Z",
    transform: "translate(1 3)",
    fill: "#f00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningAmberOutlinedRed);
export default __webpack_public_path__ + "static/media/WarningAmberOutlinedRed.803521a992495e8ae042ae6e13c56a65.svg";
export { ForwardRef as ReactComponent };